module.exports = __webpack_public_path__ + "static/parade-2019-house05-72c744d3c7e4026cc2383f99da51a910.jpg";